import { useCallback, useState } from "react";

export const useBillPaymentConfirmation = () => {
    const [showBillConfirmation, setShowBillConfirmation] = useState(false);

    const showConfirmation = useCallback(() => {
        setShowBillConfirmation(true);
    }, []);

    const hideConfirmation = useCallback(() => {
        setShowBillConfirmation(false);
    }, []);

    const handleSecondaryClick = useCallback(() => {
        hideConfirmation();
    }, [hideConfirmation]);

    return {
        showBillConfirmation,
        showConfirmation,
        hideConfirmation,
        handleSecondaryClick,
    };
};
